import { render, staticRenderFns } from "./supplytype.vue?vue&type=template&id=94b3bf08&scoped=true&"
import script from "./supplytype.vue?vue&type=script&lang=js&"
export * from "./supplytype.vue?vue&type=script&lang=js&"
import style0 from "./supplytype.vue?vue&type=style&index=0&id=94b3bf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b3bf08",
  null
  
)

export default component.exports